/**
 * World conventions shared by gameplay, level data and the asset pipeline.
 *
 * Coordinate system (Babylon.js, left-handed):
 *   +X = right, +Y = up, +Z = forward (direction of travel at yaw 0).
 *   1 world unit = 1 meter.
 * See docs/technical/ARCHITECTURE.md → "Koordinatensystem".
 */
export interface WorldConfig {
  readonly metersPerUnit: number;
  readonly laneCount: number;
  /** Width of a single lane in meters. */
  readonly laneWidth: number;
  /** Total drivable track width (laneCount × laneWidth). */
  readonly trackWidth: number;
  /** Length of the base track module (SEG_STRAIGHT_20M). */
  readonly baseSegmentLength: number;
  /** Supported module lengths – every segment length must be one of these. */
  readonly allowedSegmentLengths: readonly number[];
  readonly groundHeight: number;
  /** Below this height the player is considered fallen out of the world. */
  readonly killHeight: number;
}

const LANE_COUNT = 3;
const LANE_WIDTH = 2.2;

export const WORLD_CONFIG: WorldConfig = {
  metersPerUnit: 1,
  laneCount: LANE_COUNT,
  laneWidth: LANE_WIDTH,
  trackWidth: LANE_COUNT * LANE_WIDTH,
  baseSegmentLength: 20,
  allowedSegmentLengths: [20, 40, 60],
  groundHeight: 0,
  killHeight: -6,
};
